<template>
    <div class="workflow">
        <div
            class="workflow-item__header"
            :class="{ 'clickable': !alarmPreviewed.pipelines.length }"
        >
            <span class="workflow-item__header__icon">
                <icon
                    class="icon-primary"
                    icon="paste-solid"
                    :height="20"
                    :width="20"
                ></icon>
            </span>
            <h3 class="workflow-item__header__text">
                {{alarmPreviewed.pipelines.length ? 'Start Workflow': 'Click to add first workflow block'}}
            </h3>
        </div>
        <span v-if="alarmPreviewed.pipelines.length" class="workflow-item__end-icon">
            <icon
                icon="long-arrow-down-solid"
                :height="55"
                :width="15"
            ></icon>
        </span>
        <div class="draggable-wrapper">
            <v-expansion-panel :disabled="workflowStatus" :value="alarmPreviewed.pipelines.length - 1" class="draggable-panel">
                <draggable
                    class="list-group"
                    :list="alarmPreviewed.pipelines"
                    animation="400"
                    :disabled="workflowStatus"
                    :handle="'.workflow__item__panel'"
                    dragClass="dragging-block"
                >
                    <div
                        class="wrapper"
                        v-for="(alarmItem, index) in alarmPreviewed.pipelines"
                        :key="alarmItem.id"
                    >
                        <device-alarms-workflow-item
                            :alarm-processed="alarmItem"
                            :index="index"
                            :available-alarm-type-ids="availableAlarmTypeIds"
                            @deleteRecipient="onDeleteRecipient"
                            @addRecipient="onAddRecipient"
                            @typeChange="onTypeChange"
                            @deleteItem="onDeleteItem"
                            @disableWorkflow="onDisableWorkflow"
                        ></device-alarms-workflow-item>
                        <span
                            class="workflow-item__end-icon">
                            <icon
                                icon="long-arrow-down-solid"
                                :height="55"
                                :width="15"
                            ></icon>
                        </span>
                    </div>
                </draggable>
            </v-expansion-panel>
            <div
                class="btn-group"
                style="padding: 20px; margin-top: 20px;"
            >
                <sp-btn :disabled="workflowStatus || !hasAnyAlarmToAdd" icon="add" text="Add Action" @click.native="onAddAction"></sp-btn>
                <sp-btn :disabled="workflowStatus" icon="download" text="Save" @click.native="onSaveWorkflow"></sp-btn>
            </div>
        </div>
    </div>
</template>

<script>

import DeviceAlarmsWorkflowItem from '@/views/_components/alarmsPipelines/DeviceAlarmsWorkflowItem'
import SpBtn from '@/components/forms/SpBtn'
import Icon from '@/components/atoms/Icon'
import draggable from 'vuedraggable'
import { JSONClone } from '@/helpers/Utils'
import { mapGetters } from 'vuex'

export default {
    name: 'DeviceAlarmsWorkflow',
    components: {
        DeviceAlarmsWorkflowItem,
        SpBtn,
        Icon,
        draggable
    },
    mounted () {
        this.calculateAvailableAlarmTypes()
    },
    data () {
        return {
            alarmPreviewed: JSONClone(this.alarmProcessed),
            workflowStatus: false,
            possibleAlarmTypeIds: [1, 3],
            availableAlarmTypeIds: []
        }
    },
    props: {
        alarmProcessed: {
            type: [Object, null],
            required: true
        }
    },
    watch: {
        'alarmProcessed': {
            handler (newVal) {
                if (newVal) {
                    this.alarmPreviewed = JSONClone(newVal)
                    this.calculateAvailableAlarmTypes()
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            getAlarmPipelines: 'dictionaryModule/getAlarmPipelines'
        }),
        hasAnyAlarmToAdd () {
            return 0 < this.availableAlarmTypeIds.length
        }
    },
    methods: {
        onAddAction () {
            if (!this.availableAlarmTypeIds.length) {
                return
            }

            const randomId = '_' + Math.random().toString(36).substr(2, 9)
            const alarmTemplate = this.alarmObjectTypeTemplate(this.availableAlarmTypeIds.shift(), randomId)
            this.alarmPreviewed.pipelines.push(alarmTemplate)
        },
        onTypeChange ({ alarmType, index }) {
            const currentId = this.alarmPreviewed.pipelines[index].id
            this.$set(this.alarmPreviewed.pipelines, index, this.alarmObjectTypeTemplate(alarmType, currentId))

            this.calculateAvailableAlarmTypes()
        },
        onDeleteItem (index) {
            this.alarmPreviewed.pipelines.splice(index, 1)
            this.calculateAvailableAlarmTypes()
        },
        onAddRecipient (index, recipientEmail) {
            this.alarmPreviewed.pipelines[index].recipients.push(recipientEmail)
        },
        onDeleteRecipient (index, recipientEmail) {
            this.alarmPreviewed.pipelines[index].recipients = this.alarmPreviewed.pipelines[index].recipients.filter(recipient => recipient !== recipientEmail)
        },
        alarmObjectTypeTemplate (alarmType, currentId) {
            let obj = {}
            switch (alarmType) {
                case 1:
                    obj = {
                        id: currentId,
                        type: 1,
                        channels: [],
                        eventClassification: ''
                    }
                    break
                case 3:
                    obj = {
                        id: currentId,
                        type: 3,
                        recipients: [],
                        subject: ''
                    }
                    break
            }
            return obj
        },
        onDisableWorkflow (value) {
            this.workflowStatus = value
        },
        onSaveWorkflow () {
            this.$emit('updateWorkflow', this.alarmPreviewed)
        },
        calculateAvailableAlarmTypes () {
            const usedAlarmTypeIds = []
            this.alarmPreviewed.pipelines.forEach(alarm => {
                usedAlarmTypeIds.push(alarm.type)
            })

            const availableAlarmTypeIds = this.possibleAlarmTypeIds.filter(alarmId => {
                return !usedAlarmTypeIds.includes(alarmId)
            })
            this.availableAlarmTypeIds.splice(0, availableAlarmTypeIds.length, ...availableAlarmTypeIds)
        }
    }
}

</script>

<style lang="scss" scoped>
.workflow {
    display: flex;
    flex-direction: column;
    color: $font;
    width: 500px;
    .workflow-item {
        &__header {
            display: flex;
            border: 1px solid black;
            color: $font;
            &__icon {
                background: $primary;
                display: inline-block;
                padding: 5px;
            }
            &__text {
                width: 100%;
                display: flex;
                padding: 5px 5px 5px 15px;
                font-weight: 500;
                font-size: 1rem;
                background: $secondary;
                justify-content: flex-start;
                align-items: center;
            }
    }
    }
    .clickable {
        cursor: pointer;
    }
    .icon-primary {
        color: $icon-primary;
    }
}
.btn-group {
    display: flex;
    justify-content: space-between;
}

::v-deep.v-expansion-panel {
    box-shadow: none;
}

::v-deep .v-expansion-panel__header {
    padding: 0;
    min-height: auto;
    background: $secondary;
    box-shadow: 4px solid teal;
    .workflow-item__header {
        border: none;
    }
    &__icon {
        background: $secondary;
        height: 100%;
        i {
            color: $font !important;
        }
    }
}
.flip-list-move {
  transition: transform 0.5s;
}
.workflow-item__end-icon {
    display: block;
    text-align: center;
    visibility: visible;
    color: $inactive;
}

.wrapper:last-of-type .workflow-item__end-icon {
   display: none;
}
.workflow__item__panel {
    border: 1px solid black;
}
.dragging-block .workflow-item__end-icon {
    visibility: hidden;
}

.draggable-wrapper {
    display: flex;
    flex-direction: column;
    width: 500px;
    background: rgb(255, 255, 255);
    .draggable-panel {
        display: flex;
        flex-direction: column;
    }
}
</style>
